// EmmA's face in the CRM. The art and its rules live in emma-hub (docs/EMMA-BRAND.md, public/brand/);
// these three files are copied from there. She guides; the CRM's own palette and Artemis stay in front,
// so only her avatar and her pose carry the character here — never a repaint of the CRM.
import {cn} from '@aiw/ui';

export function EmmaAvatar({ size = 24, busy = false, className }: { size?: number; busy?: boolean; className?: string }) {
  return (
    <img
      src={size > 32 ? '/brand/emma-avatar-128.webp' : '/brand/emma-avatar-64.webp'}
      width={size}
      height={size}
      alt="EmmA"
      draggable={false}
      className={cn('shrink-0 rounded-full bg-muted', busy && 'motion-safe:animate-pulse', className)}
    />
  );
}

/** Her pointing-at-a-plan pose, for an empty conversation. Ground already cut away. */
export function EmmaPlanPose({ height = 96 }: { height?: number }) {
  return <img src="/brand/emma-plan.webp" height={height} style={{ height }} alt="" aria-hidden="true" draggable={false} className="w-auto" />;
}
